import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  min-height: 100%;
  padding: 2rem;
  padding-bottom: 0.5rem;

  background-color: var(--color-primaryDark);
  color: var(--color-reverse);

  @media only screen and (max-width: 767px) {
    padding: 0.5rem;
    padding-top: 2rem;
  }
`

export const Content = styled.div`
  width: 855px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  flex-flow: column;

  input {
    width: 100%;
    height: 50px;
    color: black;
    background: #fff;
    border: 2px solid #bdbdbd;
    border-radius: 4px;
    box-shadow: inset 0 1px 2px 1px rgba(0, 0, 0, 0.05);
    font-size: 18px;
    font-weight: 400;
    line-height: 48px;
    padding: 0 1rem;
    -webkit-font-smoothing: antialiased;
    transition: all 0.2s ease;
  }

  @media only screen and (max-width: 1024px) {
    width: 90%;
  }

  @media only screen and (max-width: 767px) {
    width: 100%;
    margin-top: 2rem;
  }
`

export const SearchArticles = styled.ul`
  display: flex;
  flex-flow: column;
  list-style-type: none;
  margin: 0;
`

export const SearchArticle = styled.li`
  border-radius: 10px;
  overflow: hidden;
  margin: 0;
  margin-top: 1rem;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  background-color: var(--color-primary);

  a {
    text-decoration: none;
  }

  &:hover,
  &:focus {
    background-color: var(--color-primaryDark);
  }

  @media only screen and (max-width: 767px) {
    height: 100%;
  }
`

export const SearchArticleData = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: space-around;
  min-height: 150px;

  @media only screen and (max-width: 767px) {
    flex-flow: column;
  }
`

export const SearchArticleImage = styled.div`
  width: 30%;

  img {
    width: 100%;
    height: 100%;
    margin: 0;
    object-fit: cover;

    transition: all 0.5s;
    display: block;
  }

  @media only screen and (max-width: 767px) {
    width: 100%;
  }
`

export const SearchArticleNonImage = styled.div`
  width: 70%;
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  padding: 1rem;

  h3 {
    font-size: 1.5rem;
    line-height: 1.8rem;
  }

  div {
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    font-size: 1.2rem;

    span {
      color: var(--color-primaryCompliment);
    }
  }

  @media only screen and (max-width: 767px) {
    width: 100%;
    padding: 1rem;

    h3 {
      font-size: 1.4rem;
    }

    div {
      font-size: 1rem;

      span:first-child {
        margin-right: 10px;
      }
    }
  }
`

export const ButtonsDiv = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  padding-top: 1rem;

  button {
    font-size: 1.1rem;
  }
`
